import { TextWithIcon, Typography } from '@HomaHealth/ui-component-library';
import HighToLow from '../../_components/atoms/Icons/HighToLow';
import LowToHigh from '../../_components/atoms/Icons/LowToHigh';
import React from 'react';
import roverTheme from '@HomaHealth/ui-component-library/lib/theme/theme';
import { tableSortConstants } from '../messages/tableSortMessages';

export const handleHeaderMouseEnter = (column: any, setColumnId?: any) => {
  setColumnId(column?.id || column?.sortColumnName);
};

export const handleHeaderMouseLeave = (setColumnId?: any) => {
  setColumnId('');
};

export const dropDownMenuItemsValues = [
  {
    text: (
      <TextWithIcon
        iconSrc={<HighToLow />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {tableSortConstants.TABLE_NUMBER_SORT[0]}
          </Typography>
        }
      />
    ),
    actionType: 'descendingSorting',
  },
  {
    text: (
      <TextWithIcon
        iconSrc={<LowToHigh />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {tableSortConstants.TABLE_NUMBER_SORT[1]}
          </Typography>
        }
      />
    ),
    actionType: 'ascendingSorting',
  },
];

export const dropDownMenuItemsAlphabets = [
  {
    text: (
      <TextWithIcon
        iconSrc={<HighToLow />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {tableSortConstants.TABLE_ALPHABET_SORT[0]}
          </Typography>
        }
      />
    ),
    actionType: 'descendingSorting',
  },
  {
    text: (
      <TextWithIcon
        iconSrc={<LowToHigh />}
        text={
          <Typography
            lineHeight="24px"
            textColor={roverTheme.palette.text.primary}
            fontType="regular"
            fontSize="12px"
          >
            {tableSortConstants.TABLE_ALPHABET_SORT[1]}
          </Typography>
        }
      />
    ),
    actionType: 'ascendingSorting',
  },
];
